(() => {
  const configNode = document.querySelector('[data-es-config]');
  if (!configNode) return;
  const config = JSON.parse(configNode.textContent);
  const text = config.strings;
  const groups = [
    ['コルセット','corset','corsets','waist cincher','waist cinchers'],
    ['ビスチェ','ビスチエ','bustier','bustiers'],
    ['キャミソール','キャミ','camisole','camisoles','cami'],
    ['トップス','トップ','tops','top'],['タンクトップ','tank top','tank tops'],
    ['ワンピース','ワンピ','ドレス','dress','dresses'],
    ['スカート','skirt','skirts'],['パンツ','ズボン','pants','trousers'],
    ['ショートパンツ','ショーパン','shorts'],['デニム','ジーンズ','denim','jeans'],
    ['ジャケット','jacket','jackets'],['コート','coat','coats'],
    ['ファー','fur','faux fur'],['カーディガン','cardigan','cardigans'],
    ['ニット','セーター','knit','knitwear','sweater','sweaters'],
    ['ブラウス','blouse','blouses'],['シャツ','shirt','shirts'],
    ['ランジェリー','lingerie','lingeries'],['ブラジャー','ブラ','bra','bras'],
    ['バッグ','鞄','カバン','bag','bags'],['シューズ','靴','クツ','shoes','shoe'],
    ['ブーツ','boots','boot'],['ヒール','heels','heel'],['サンダル','sandals','sandal'],
    ['ベルト','belt','belts'],['アクセサリー','accessory','accessories'],
    ['ネックレス','necklace','necklaces'],['帽子','ハット','hat','hats'],
    ['ピンク','pink'],['白','ホワイト','white'],['黒','ブラック','black'],
    ['赤','レッド','red'],['青','ブルー','blue'],['紫','パープル','purple'],
    ['茶色','ブラウン','brown'],['ゴールド','金色','gold','golden'],
    ['シルバー','銀色','silver'],['ベージュ','beige'],['クリーム','cream'],
    ['緑','グリーン','green'],['グレー','灰色','gray','grey'],
    ['レース','lace'],['リボン','ボウ','ribbon','ribbons','bow','bows'],
    ['フリル','ruffle','ruffles','frill','frills'],['花柄','フローラル','floral','flower','flowers'],
    ['ヒョウ柄','豹柄','レオパード','leopard'],['水玉','ドット','polka dot','dot','dots'],
    ['ヴィンテージ','ビンテージ','vintage'],['レザー','革','leather'],['サテン','satin'],
    ['ベルベット','velvet'],['シルク','silk'],['ハート','heart','hearts'],
    ['ハートブレイカー','heartbreaker'],['イットガール','it girl','it-girl'],
    ['スポイルドエンジェル','spoiled angel'],['レベルプリンセス','rebel princess'],
    ['トラブルメーカー','trouble maker'],['ホットジンジャー','hot ginger'],
    ['プライベートスクール','private school'],['ゴールデンガール','golden girl']
  ];
  const normalize = value => String(value ?? '').normalize('NFKC').toLowerCase()
    .replace(/[ぁ-ゖ]/g, char => String.fromCharCode(char.charCodeAt(0) + 0x60))
    .replace(/[’']/g, '').replace(/\s+/g, ' ').trim();
  const aliases = groups.map(group => group.map(normalize));
  const hasAlias = (source, alias) => {
    if (!/^[a-z0-9 -]+$/.test(alias)) return source.includes(alias);
    const start = source.indexOf(alias);
    if (start < 0) return false;
    return source.split(alias).some((part, index, parts) => index < parts.length - 1 &&
      !/[a-z]$/.test(part) && !/^[a-z]/.test(parts[index + 1]));
  };
  function prepare(product) {
    const title = normalize(product.title);
    const source = normalize([product.title, product.type, product.category, product.description,
      ...(product.tags || []), ...(product.collections || []), ...(product.skus || [])].join(' '));
    const expanded = aliases.filter(group => group.some(alias => hasAlias(source, alias))).flat();
    return { ...product, normalizedTitle: title, searchable: `${source} ${expanded.join(' ')}` };
  }
  function match(products, query) {
    const normalized = normalize(query);
    const tokens = normalized.split(/\s+/).filter(Boolean);
    if (!tokens.length) return [];
    return products.filter(product => tokens.some(token => product.searchable.includes(token)))
      .map(product => ({ product, score: tokens.filter(token => product.searchable.includes(token)).length * 4 + (product.normalizedTitle === normalized ? 3 :
        product.normalizedTitle.startsWith(normalized) ? 2 : product.normalizedTitle.includes(normalized) ? 1 : 0) }))
      .sort((a, b) => b.score - a.score || Number(b.product.available) - Number(a.product.available) ||
        Number(b.product.published) - Number(a.product.published) || a.product.id.localeCompare(b.product.id))
      .map(item => item.product);
  }
  const nativeQuery = query => /[:"*()]/.test(query);
  let memory;
  let pending;
  const cacheKey = `euphoria:search:${config.key}:v1`;
  async function indexPage(page) {
    const url = new URL(config.indexUrl, location.origin);
    url.searchParams.set('section_id', 'euphoria-search-index');
    if (window.Shopify?.theme?.role === 'unpublished') url.searchParams.set('preview_theme_id', Shopify.theme.id);
    url.searchParams.set('sort_by', 'created-descending');
    url.searchParams.set('page', page);
    const response = await fetch(url, { credentials: 'same-origin', signal: AbortSignal.timeout(15000) });
    if (!response.ok) throw new Error('Search index request failed');
    const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
    const node = doc.querySelector('[data-euphoria-search-index]');
    if (!node) throw new Error('Search index unavailable');
    return JSON.parse(node.textContent);
  }
  const parallel = 6;
  async function indexPages(numbers) {
    const pages = [];
    let next = 0;
    await Promise.all(Array.from({ length: Math.min(parallel, numbers.length) }, async () => {
      while (next < numbers.length) {
        const page = numbers[next++];
        const data = await indexPage(page);
        if (data.page !== page) throw new Error('Catalog changed');
        pages.push(data);
      }
    }));
    return pages;
  }
  async function load() {
    if (memory?.expires > Date.now()) return memory.products;
    if (pending) return pending;
    pending = (async () => {
      try {
        const saved = JSON.parse(sessionStorage.getItem(cacheKey));
        if (saved?.expires > Date.now() && Array.isArray(saved.products)) {
          memory = { expires: saved.expires, products: saved.products.map(prepare) };
          return memory.products;
        }
      } catch (_) {}
      // 商品数から求めたページ数で全ページを同時に取得し、1ページ目を待ってからの往復を省く。
      // 表示後の商品追加・非公開化でページ数が変わっていても、実際の応答に合わせて不足分を取得する。
      const hinted = Number.isInteger(config.pages) && config.pages >= 1 && config.pages <= 100 ? config.pages : 1;
      let pages = await indexPages(Array.from({ length: hinted }, (_, i) => i + 1));
      const first = pages.find(page => page.page === 1);
      if (!Number.isInteger(first.pages) || first.pages < 1 || first.pages > 100) throw new Error('Invalid search index');
      const missing = Array.from({ length: first.pages }, (_, i) => i + 1).filter(n => !pages.some(page => page.page === n));
      pages = pages.filter(page => page.page <= first.pages).concat(await indexPages(missing));
      if (pages.some(data => data.total !== first.total || data.pages !== first.pages)) throw new Error('Catalog changed');
      pages.sort((a, b) => a.page - b.page);
      const products = pages.flatMap(page => page.products);
      if (products.length !== first.total || new Set(products.map(product => product.id)).size !== first.total) throw new Error('Incomplete search index');
      const expires = Date.now() + 60000;
      try { sessionStorage.setItem(cacheKey, JSON.stringify({ expires, products })); } catch (_) {}
      memory = { expires, products: products.map(prepare) };
      return memory.products;
    })().finally(() => { pending = null; });
    return pending;
  }
  const node = (tag, className, value) => {
    const element = document.createElement(tag);
    if (className) element.className = className;
    if (value !== undefined) element.textContent = value;
    return element;
  };
  function image(product, width, eager = false) {
    if (!product.image) return node('span', 'es-card__image');
    const img = node('img', 'es-card__image');
    const url = new URL(product.image, location.origin);
    url.searchParams.set('width', width);
    img.src = url.href; img.width = width; img.height = width;
    img.alt = product.title; img.loading = eager ? 'eager' : 'lazy'; img.decoding = 'async';
    return img;
  }
  function price(product) {
    const result = node('p', 'es-card__price');
    if (product.compare) result.append(node('s', '', product.compare), ' ');
    result.append(node('span', '', product.price));
    return result;
  }
  function card(product, eager) {
    const item = node('li', 'es-card');
    const link = node('a', 'es-card__link'); link.href = product.url;
    link.append(image(product, 600, eager), node('h3', 'es-card__title', product.title));
    item.append(link, price(product));
    const badges = node('div', 'es-card__badges');
    if (!product.available) badges.append(node('span', 'es-card__badge', text.sold));
    if (product.compare) badges.append(node('span', 'es-card__badge', text.sale));
    const age = Date.now() / 1000 - Number(product.published);
    if (Number(product.published) > 0 && age >= 0 && age < 604800) badges.append(node('span', 'es-card__badge', 'NEW'));
    item.append(badges);
    const wish = node('button', 'wishlist-toggle wishlist-toggle--card'); wish.type = 'button';
    Object.assign(wish.dataset, { wishlistToggle: '', productHandle: product.handle, productTitle: product.title,
      productUrl: product.url, productImage: product.image || '', productPrice: product.price,
      variantId: product.variant, productAvailable: String(product.available) });
    wish.setAttribute('aria-label', text.wishlist.replace('{title}', product.title));
    let selected = false;
    try { selected = JSON.parse(localStorage.getItem('euphoria:wishlist:v1') || '[]').some(item => item.handle === product.handle); } catch (_) {}
    wish.setAttribute('aria-pressed', String(selected)); wish.classList.toggle('is-active', selected);
    const heart = node('span', '', '♡'); heart.setAttribute('aria-hidden', 'true'); wish.append(heart); item.append(wish);
    return item;
  }
  async function predictive(instance, query) {
    instance.setLiveRegionLoadingState();
    const products = match(await load(), query);
    if (instance.getQuery() !== query || !instance.isConnected) return;
    const wrapper = node('div'); wrapper.id = 'predictive-search-results-groups-wrapper';
    const list = node('ul', 'predictive-search__results-list list-unstyled');
    list.setAttribute('role', 'group'); list.setAttribute('aria-label', text.products);
    products.forEach((product, index) => {
      const item = node('li', 'predictive-search__list-item'); item.id = `predictive-search-option-enhanced-${index}`;
      item.setAttribute('role', 'option'); item.setAttribute('aria-selected', 'false');
      const link = node('a', 'predictive-search__item predictive-search__item--link-with-thumbnail link link--text');
      link.href = product.url; link.tabIndex = -1;
      const img = image(product, 100, index < 8); img.className = 'predictive-search__image';
      const copy = node('div', 'predictive-search__item-content');
      copy.append(node('p', 'predictive-search__item-heading h5', product.title), price(product));
      link.append(img, copy); item.append(link); list.append(item);
    });
    wrapper.append(list);
    const button = node('button', 'predictive-search__item predictive-search__item--term link link--text h5');
    button.type = 'submit'; button.setAttribute('role', 'option'); button.setAttribute('aria-selected', 'false');
    button.id = 'predictive-search-option-search-keywords';
    const label = node('span', '', text.all.replace('{query}', query)); label.dataset.predictiveSearchSearchForText = '';
    button.append(label); wrapper.append(button);
    const status = node('span', 'hidden', text.count.replace('{count}', products.length).replace('{query}', query));
    status.dataset.predictiveSearchLiveRegionCountValue = ''; status.dataset.totalResults = products.length;
    wrapper.append(status); instance.renderSearchResults(wrapper.outerHTML);
  }
  async function results() {
    const panel = document.querySelector('[data-es-results]');
    const params = new URLSearchParams(location.search);
    const query = params.get('q')?.trim();
    if (!panel || !query || nativeQuery(query) || [...params.keys()].some(key => key.startsWith('filter.'))) return;
    const status = node('p', 'es-status', text.loading); status.setAttribute('role', 'status');
    panel.hidden = false; panel.append(status);
    try {
      const products = match(await load(), query);
      const native = document.querySelector('#ProductGridContainer');
      if (native) {
        const disclosure = node('details', 'es-native');
        disclosure.append(node('summary', '', text.standard)); native.before(disclosure); disclosure.append(native);
      }
      document.querySelectorAll('.template-search__header p[role="status"]').forEach(element => { if (!panel.contains(element)) element.hidden = true; });
      document.querySelector('.template-search')?.classList.remove('template-search--empty');
      const grid = node('ul', 'es-grid'); grid.setAttribute('role', 'list');
      status.textContent = text.count.replace('{count}', products.length).replace('{query}', query);
      grid.replaceChildren(...products.map((product, index) => card(product, index < 2)));
      panel.append(grid); panel.dataset.esReady = 'true';
    } catch (_) { panel.replaceChildren(); panel.hidden = true; }
  }
  window.EuphoriaSearch = { load, match, normalize, prepare, nativeQuery, predictive };
  results();
})();
